var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    className: "wd-icon-inbox-large wd-icon",
    focusable: "false",
    role: "presentation",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    className: "wd-icon-container"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 11l7.003-.007V12h7.991v-1.007h7.059V21L1 21.007z",
    className: "wd-icon-background",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3 10h6.19a.5.5 0 0 1 .51.505V12h6v-1.495c0-.279.222-.505.51-.505h6.194l-2.778-6H5.12L2.3 10zM22 12h-5v1.495a.507.507 0 0 1-.51.505H7.51a.5.5 0 0 1-.51-.505V12H2v8h20v-8zM3.772 2.417c.153-.23.506-.417.776-.417h14.954c.275 0 .622.187.773.415L24 10v11.492c0 .28-.225.508-.494.508H.494A.5.5 0 0 1 0 21.494V10l3.772-7.583z",
    className: "wd-icon-fill",
    fill: "#7b858f"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 2,
    x: 7,
    y: 16,
    className: "wd-icon-accent",
    rx: 0.5,
    fill: "#7b858f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavInbox);
export default __webpack_public_path__ + "static/media/navInbox.9a6c9f011f84e9b9335520ab05bc6625.svg";
export { ForwardRef as ReactComponent };